/**
 * Require check for validation
 * @param {any} fieldValue
 * @return {boolean}
 */
export default function requiredRule(fieldValue) {
    // for checkboxes / multiple dropdown
    if (Array.isArray(fieldValue)) {
        return fieldValue.length > 0
    }

    // unset values (e.g. a date control that emits null when never picked)
    if (fieldValue === null || fieldValue === undefined) {
        return false
    }

    // for text/any string: empty or whitespace-only fails
    if (typeof fieldValue === "string") {
        return fieldValue.trim() !== ""
    }

    // moment / Date-like objects: an unset/invalid date is "empty"
    if (typeof fieldValue === "object" && typeof fieldValue.isValid === "function") {
        return fieldValue.isValid()
    }

    // numbers, booleans, other concrete values
    return true
}